jQuery(document).ready(function($){
	var mainHeader = $('.faktotum-auto-hide-header'),
		secondaryNavigation = $('.faktotum-secondary-nav'),
		navTrigger = $('.js-nav-trigger'),
		navWrapper = $('.js-nav-wrapper'),
		//this applies only if secondary nav is below intro section
		belowNavHeroContent = $('.sub-nav-hero'),
		headerHeight = mainHeader.height(),
		menuHasChildren = $('.menu-item-has-children > a'),
		subMenu = $('.sub-menu'),
		// firstLi = $('#menu-main-menu li:first-child'),
		menuOpen = false;
	
	//set scrolling variables
	var scrolling = false,
		previousTop = 0,
		currentTop = 0,
		scrollDelta = 10,
		scrollOffset = 150;

	mainHeader.on('click', '.nav-trigger', function(event){
		if ($(window).width() >= 992) {
		var noOpenMenuItems = $('#menu-main-menu li.open').length === 0;
		var noOpenSubMenus = $('.faktotum-primary-nav .sub-menu.open').length === 0;
		if (noOpenMenuItems && noOpenSubMenus) {
			$('#menu-main-menu li:first-child').addClass('open');
			$('.faktotum-primary-nav .sub-menu:first-child').addClass('open');
		}
			// $('#menu-main-menu li:first-child').addClass('open');
			// $('.faktotum-primary-nav .sub-menu:first-child').addClass('open');
		}
		$('body').toggleClass('menu-open');
		mainHeader.toggleClass('menu-open');
		event.preventDefault();
		navWrapper.toggleClass('menu-open');
		menuOpen = !menuOpen;
	});

	$(document).on('click', function(event) {
        // Check if the navigation is open and the clicked element is not a descendant of navTrigger or navWrapper
        if (menuOpen && !$(event.target).closest(navTrigger).length && !$(event.target).closest(navWrapper).length) {
            navWrapper.removeClass('menu-open');
			menuOpen = false;
        }
    });

	// move subnav
	/////////////////////////var parentId = $(this).parent('.menu-item').attr('id');
	// sub-menu
	// menuHasChildren.on('click touch', function(event) {
		
	// 	event.preventDefault();
	// 	$('.menu-item').removeClass('open');
	// 	$(this).parent('.menu-item').toggleClass('open');
	// 	$(this).siblings(subMenu).toggleClass('open');
	// });
//////////////////////////////////
	// function moveSubMenus() {
	// 	if ($(window).width() >= 992) {
	// 		// Move sub-menus to .js-sub-menu-wrap if screen width is >= 992px
	// 		$('.menu-item-has-children').each(function() {
	// 			var $menuItem = $(this);
	// 			var $subMenu = $menuItem.find('.sub-menu');
	// 			if ($subMenu.length && !$subMenu.attr('data-parent-id')) {
	// 				var parentId = $menuItem.attr('id');
	// 				$subMenu.attr('data-parent-id', parentId); // Assign data attribute
	// 				$('.js-sub-menu-wrap').append($subMenu); // Move to .js-sub-menu-wrap
	// 			}
	// 		});
	// 	} else {
	// 		// Move sub-menus back to their original parent if screen width is < 992px
	// 		$('.js-sub-menu-wrap .sub-menu').each(function() {
	// 			var $subMenu = $(this);
	// 			var parentId = $subMenu.attr('data-parent-id');
	// 			$('#' + parentId).append($subMenu);
	// 			// $subMenu.removeAttr('data-parent-id');
	// 		});
	// 	}
	// }

	// moveSubMenus(); // Call on page load

	// // Call on window resize
	// $(window).on('resize', function() {
	// 	moveSubMenus();
	// });

	// // jQuery function to handle clicks on menu items
	// $('.menu-item-has-children > a').on('click touch', function(event) {
	// 	event.preventDefault();
	// 	var parentId = $(this).parent('.menu-item-has-children').attr('id');
	// 	var $subMenu = $('.js-sub-menu-wrap').find('ul[data-parent-id="' + parentId + '"]');
	// 	var $subMenuWrap = $('.js-sub-menu-wrap').find('ul[data-parent-id="' + parentId + '"]');
	// 	$('.menu-item').removeClass('open');
	// 	$('.js-sub-menu-wrap ul').removeClass('open'); // Close all sub-menus
	// 	$(this).parent('.menu-item').toggleClass('open');
	// 	$subMenuWrap.toggleClass('open');
	// });

	/////////////////////////////////

	handleSubMenus($(window).width());

  // Check screen size on window resize
  $(window).resize(function() {
    handleSubMenus($(window).width());
  });

  // Function to handle sub-menus based on screen size
  function handleSubMenus(windowWidth) {
    if (windowWidth >= 992) {
      moveSubMenus();
    } else {
      resetSubMenus();
    }
  }

  // Move .sub-menu elements to .js-sub-menu-wrap and assign data-attribute
  function moveSubMenus() {
    $('.menu-item-has-children').each(function() {
      var $this = $(this);
      var subMenu = $this.find('.sub-menu');
      if (subMenu.length) {
        subMenu.appendTo('.js-sub-menu-wrap').attr('data-parent-id', $this.attr('id'));
      }
    });
  }

  // Reset .sub-menu elements back to their parent .menu-item
  function resetSubMenus() {
    $('.js-sub-menu-wrap .sub-menu').each(function() {
      var $this = $(this);
      var parentID = $this.attr('data-parent-id');
      $('#' + parentID).append($this);
      $this.removeAttr('data-parent-id');
    });
  }

  // Update the click handler
//   $('.menu-item-has-children > a').on('click touch', function(event) {
//     event.preventDefault();
//     var parentID = $(this).parent('.menu-item').attr('id');

//     if ($(window).width() >= 992) {
//       // For larger screens, close any open sub-menus and open the clicked one
//       $('.js-sub-menu-wrap .sub-menu').removeClass('open');
//       $('.menu-item').removeClass('open');
//       $(this).parent('.menu-item').toggleClass('open');
//       $('.js-sub-menu-wrap .sub-menu[data-parent-id="' + parentID + '"]').toggleClass('open');
//     } else {
//       // For smaller screens, close any open sub-menus and open the clicked one
//       $('.menu-item .sub-menu').removeClass('open');
//       $('.menu-item').removeClass('open');
//       $(this).parent('.menu-item').toggleClass('open');
//       $(this).siblings('.sub-menu').toggleClass('open');
// 	//   $(this).parent('.menu-item-has-children').toggleClass('open');
//     }
//   });

// updated
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
jQuery(document).ready(function($) {
	// Function to update the active menu image
    function updateActiveMenuImage(menuItemID) {
        var menuImageElement = $('.js-menu-image[data-menu-id="' + menuItemID + '"]');
        if (menuImageElement.length) {
            var newImageSrc = menuImageElement.attr('src');
            $('.js-active-menu-image > img').attr('src', newImageSrc);
        }
    }

    // Check current menu item on page load
    $(window).on('load', function() {
        var currentMenuItem = $('.current-menu-item').first();
        if (currentMenuItem.length) {
            var menuItemID = currentMenuItem.attr('id');
            updateActiveMenuImage(menuItemID);
        }
    });
    $('.menu-item-has-children > a').on('click touch', function(event) {
        event.preventDefault();
        var parentID = $(this).parent('.menu-item').attr('id');

        if ($(window).width() >= 992) {
            // For larger screens, close any open sub-menus and open the clicked one
            $('.js-sub-menu-wrap .sub-menu').removeClass('open');
            $('.menu-item').removeClass('open');
            $(this).parent('.menu-item').toggleClass('open');
            $('.js-sub-menu-wrap .sub-menu[data-parent-id="' + parentID + '"]').toggleClass('open');
        } else {
            // For smaller screens, close any open sub-menus and open the clicked one
            $('.menu-item .sub-menu').removeClass('open');
            $('.menu-item').removeClass('open');
            $(this).parent('.menu-item').toggleClass('open');
            $(this).siblings('.sub-menu').toggleClass('open');
        }

        // Check if the clicked menu item has a corresponding .js-menu-image element
        var menuImageElement = $('.js-menu-image[data-menu-id="' + parentID + '"]');
        if (menuImageElement.length) {
            var newImageSrc = menuImageElement.attr('src');
            $('.js-active-menu-image > img').attr('src', newImageSrc);
        }
    });
	// Select all ul.sub-menu elements
    $('ul.sub-menu').each(function() {
        // Check if any li within this ul.sub-menu has the class .current-menu-item
        if ($(this).find('li.current-menu-item').length) {
            // If a .current-menu-item is found, add the open class to the ul.sub-menu
            $(this).addClass('open');
        }
		// Open the ancestor for the current sub menu item
		if ($('.current-menu-ancestor').length) {
			$('.current-menu-ancestor').addClass('open');
		}
    });
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



	// $(window).on('scroll', function(){
	// 	if( !scrolling ) {
	// 		scrolling = true;
	// 		(!window.requestAnimationFrame)
	// 			? setTimeout(autoHideHeader, 250)
	// 			: requestAnimationFrame(autoHideHeader);
	// 	}
	// });

	$(window).on('resize', function(){
		headerHeight = mainHeader.height();
	});

	function autoHideHeader() {
		var currentTop = $(window).scrollTop();

		( belowNavHeroContent.length > 0 ) 
			? checkStickyNavigation(currentTop) // secondary navigation below intro
			: checkSimpleNavigation(currentTop);

	   	previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation(currentTop) {
		//there's no secondary nav or secondary nav is below primary nav
	    if (previousTop - currentTop > scrollDelta) {
	    	//if scrolling up...
	    	mainHeader.removeClass('is-hidden');
	    } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
	    	//if scrolling down...
	    	mainHeader.addClass('is-hidden');
	    }
	}

	function checkStickyNavigation(currentTop) {
		//secondary nav below intro section - sticky secondary nav
		var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();
		
		if (previousTop >= currentTop ) {
	    	//if scrolling up... 
	    	if( currentTop < secondaryNavOffsetTop ) {
	    		//secondary nav is not fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('fixed slide-up');
	    		belowNavHeroContent.removeClass('secondary-nav-fixed');
	    	} else if( previousTop - currentTop > scrollDelta ) {
	    		//secondary nav is fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('slide-up').addClass('fixed'); 
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}
	    	
	    } else {
	    	//if scrolling down...	
	 	  	if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
	    		mainHeader.addClass('is-hidden');
	    		secondaryNavigation.addClass('fixed slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	} else if( currentTop > secondaryNavOffsetTop ) {
	    		//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.addClass('fixed').removeClass('slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}

	    }
	}
});